import { useQuery } from '@apollo/react-hooks'
import { GENERATE_ACCESS_TOKEN } from 'app/docs/constants/GqlQueries'

const useGetAccessToken = () => {
    const response = useQuery(GENERATE_ACCESS_TOKEN)

    return response
}

export default useGetAccessToken